import { render, staticRenderFns } from "./AppComboboxVehicleSearching.vue?vue&type=template&id=0b352862&"
import script from "./AppComboboxVehicleSearching.vue?vue&type=script&lang=js&"
export * from "./AppComboboxVehicleSearching.vue?vue&type=script&lang=js&"
import style0 from "./AppComboboxVehicleSearching.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
